import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotPrimary = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 3.5,
		fill: "#EBEFFF",
		stroke: "#7E94ED"
	})
});
export default SvgDotPrimary;
